/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Asset_Details_IncompleteInputs */

const en_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’re missing some details for this asset, so it can’t be deposited yet.`)
};

const de_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Asset fehlen uns noch einige Angaben, daher kann es noch nicht eingezahlt werden.`)
};

const pt_br2_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltam alguns detalhes deste ativo, então ele ainda não pode ser depositado.`)
};

const tr_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlığa ait bazı bilgiler eksik, bu nedenle henüz yatırılamıyor.`)
};

const zh_cn2_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产的部分信息尚不完整，因此暂时无法存入。`)
};

const zh_hk2_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資產尚欠部分資料，因此暫時無法存入。`)
};

const ko_kr2_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산의 정보가 일부 없어서 아직 입금할 수 없습니다.`)
};

const ru_ru2_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нам не хватает данных об этом активе, поэтому его пока нельзя внести.`)
};

const es_419_deposit_error_asset_details_incomplete = /** @type {(inputs: Deposit_Error_Asset_Details_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos faltan algunos datos de este activo, así que todavía no se puede depositar.`)
};

/**
* | output |
* | --- |
* | "We’re missing some details for this asset, so it can’t be deposited yet." |
*
* @param {Deposit_Error_Asset_Details_IncompleteInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_asset_details_incomplete = /** @type {((inputs?: Deposit_Error_Asset_Details_IncompleteInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Asset_Details_IncompleteInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_asset_details_incomplete(inputs)
	if (locale === "de") return de_deposit_error_asset_details_incomplete(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_asset_details_incomplete(inputs)
	if (locale === "tr") return tr_deposit_error_asset_details_incomplete(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_asset_details_incomplete(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_asset_details_incomplete(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_asset_details_incomplete(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_asset_details_incomplete(inputs)
	return es_419_deposit_error_asset_details_incomplete(inputs)
});